import { render, staticRenderFns } from "./OBtnFlotingComp.vue?vue&type=template&id=78d89d0a&"
import script from "./OBtnFlotingComp.vue?vue&type=script&lang=js&"
export * from "./OBtnFlotingComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports